import React from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { Button } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import styles from "../screens/ErrorPage.module.css";

export default function ErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className={`${styles.container}`}>
      <WarningOutlined className={`${styles.icon}`} />
      <h1 className={`${styles.title}`}>Oops! Something went wrong.</h1>
      <p className={`${styles.message}`}>
        Sorry an unexpected error occurred.
      </p>

       {/* Small crash info box */}
       {error && (
        <div className={`${styles.errorBox}`}>
          <h4>Error Details</h4>
          <pre>{error.message || 'Unknown error'}</pre>
        </div>
      )}
      <Button type="primary" size="large" onClick={handleBack}>
        Go Back
      </Button>
    </div>
  );
};




